export default "__VITE_ASSET__D_mWO0$1__"